import z from "zod";

import { AddressSchema } from "@/schemas/address";
import { isoDateSchema } from "@/types/isoDate";
import { ssnSchema } from "@/types/ssn";

export const Gender = {
  FEMALE: "female",
  MALE: "male",
  NON_BINARY: "non_binary",
  OTHER: "other",
  PREFER_NOT: "prefer_not",
} as const;
export type Gender = (typeof Gender)[keyof typeof Gender];
export const GenderSchema = z.enum(Gender);

export const GENDER_LABELS = {
  [Gender.FEMALE]: "Female",
  [Gender.MALE]: "Male",
  [Gender.NON_BINARY]: "Non-binary",
  [Gender.OTHER]: "Other",
  [Gender.PREFER_NOT]: "Prefer not to say",
} as const satisfies Record<Gender, string>;

export const RaceEthnicity = {
  AMERICAN_INDIAN: "american_indian",
  ASIAN: "asian",
  BLACK: "black",
  HISPANIC: "hispanic",
  MIXED_RACE: "mixed_race",
  PACIFIC_ISLANDER: "pacific_islander",
  WHITE: "white",
  PREFER_NOT: "prefer_not",
} as const;
export type RaceEthnicity = (typeof RaceEthnicity)[keyof typeof RaceEthnicity];
export const RaceEthnicitySchema = z.enum(RaceEthnicity);

export const RACE_ETHNICITY_LABELS = {
  [RaceEthnicity.AMERICAN_INDIAN]: "American Indian or Alaska Native",
  [RaceEthnicity.ASIAN]: "Asian",
  [RaceEthnicity.BLACK]: "Black or African American",
  [RaceEthnicity.HISPANIC]: "Hispanic or Latino",
  [RaceEthnicity.MIXED_RACE]: "Two or more races",
  [RaceEthnicity.PACIFIC_ISLANDER]: "Native Hawaiian or Pacific Islander",
  [RaceEthnicity.WHITE]: "White",
  [RaceEthnicity.PREFER_NOT]: "Prefer not to say",
} as const satisfies Record<RaceEthnicity, string>;

export const ApplicantProfileSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  middleName: z.string().nullable(),
  email: z.string(),
  phone: z.string().nullable(),
  address: AddressSchema,
  gender: GenderSchema.nullable(),
  raceEthnicity: RaceEthnicitySchema.nullable(),
  ssnProvided: z.boolean().nullable(),
  birthdate: isoDateSchema.nullable(),
});
export type ApplicantProfile = z.infer<typeof ApplicantProfileSchema>;

export const ApplicantProfileUpdateSchema = ApplicantProfileSchema.omit({
  ssnProvided: true,
}).extend({
  ssn: ssnSchema.optional(),
  birthdate: isoDateSchema.nullish(),
});
export type ApplicantProfileUpdate = z.infer<
  typeof ApplicantProfileUpdateSchema
>;
